// extracted by mini-css-extract-plugin
export default {"Trigger":"linked-pr-list-module__Trigger--iMQsc","Number":"linked-pr-list-module__Number--YlD8y"};